'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AGENT = exports.AGENT = 'AGENT';
var VISITOR = exports.VISITOR = 'VISITOR';
var BOT = exports.BOT = 'BOT';
var SYSTEM = exports.SYSTEM = 'SYSTEM';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/constants/senderTypes.js
// module id = 10
// module chunks = 2 3